<div
  class="glass-card"
  [ngClass]="[intensity, interactive ? 'interactive' : '']"
  [class.no-padding]="noPadding"
>
  <ng-content></ng-content>
</div>
